import { Phone, ArrowRight } from "lucide-react";

const HERO_BG = "https://images.unsplash.com/photo-1578662996442-48f60103fc96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxydWdnZWQlMjBkYXJrJTIwY29uY3JldGUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NjkyMDczNXww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section data-testid="hero-section" id="top" className="relative min-h-[92vh] flex items-center pt-32">
      <div
        className="absolute inset-0 bg-cover bg-center max-h-full"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24 w-full flex items-center justify-between gap-12">
        <div>
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B] mb-6 animate-in fade-in duration-700">
          Power Washing &bull; Junk Removal &bull; Snow Plowing
        </p>
        <h1 className="font-display uppercase tracking-tight text-6xl sm:text-7xl lg:text-8xl leading-[0.95] max-w-4xl [text-shadow:0_4px_20px_rgba(0,0,0,0.8)] animate-in fade-in slide-in-from-bottom-4 duration-700">
          Tough Messes.<br />
          <span className="text-[#F59E0B]">Rugged Solutions.</span>
        </h1>
        <p data-testid="hero-slogan" className="mt-6 inline-block font-display uppercase tracking-wide text-2xl sm:text-3xl text-white animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
          <span className="border-b-4 border-[#F59E0B] pb-1">Somebody's Gotta Do It!</span>
        </p>
        <p className="mt-6 text-base sm:text-lg text-neutral-300 max-w-xl leading-relaxed animate-in fade-in slide-in-from-bottom-4 duration-700 delay-150">
          Ultimate Warrior Junk and Plow tackles the jobs nobody else wants. Serving Etobicoke, Mississauga, Vaughan, Brampton and Toronto — 7 days a week.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
          <a
            data-testid="hero-quote-button"
            href="#quote"
            className="inline-flex items-center justify-center gap-2 bg-[#F59E0B] text-black font-display uppercase tracking-wider text-2xl px-8 py-4 hover:bg-[#D97706] transition-colors duration-200 active:scale-95"
          >
            Get Free Quote <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
          </a>
          <a
            data-testid="hero-call-button"
            href="tel:+14165086931"
            className="inline-flex items-center justify-center gap-2 border border-white/30 text-white font-display uppercase tracking-wider text-2xl px-8 py-4 hover:bg-white/10 hover:border-[#F59E0B] transition-colors duration-200 active:scale-95"
          >
            <Phone className="w-5 h-5" strokeWidth={2.5} /> Call 416-508-6931
          </a>
        </div>
        </div>
        <img
          src="/logo.png"
          alt="Ultimate Warrior Junk and Plow Removal logo"
          data-testid="hero-logo"
          className="hidden lg:block w-[380px] shrink-0 drop-shadow-[0_0_40px_rgba(0,0,0,0.9)] animate-in fade-in zoom-in-95 duration-700 delay-200"
        />
      </div>
    </section>
  );
}
